import { AppPage } from './components'
import { AppPageHeader } from './components'

import { AppDialog, AppDialogLoading, AppDialogConfirm, AppDialogDatePicker, AppDialogDatePickerPeriod } from './components'

import { AppToolbar, AppToolbarItem, AppToolbarItemPeriod, AppToolbarItemPeriodShort } from './components'
// import { AppDivider } from './components'

import { AppList, AppEmptyList, AppDatePicker, AppSelect, AppCombobox, AppTagsCombobox } from './components'
import { AppTextField, AppTextarea } from './components'

import { AppButton, AppButtonAction, AppButtonCancel } from './components'
import { AppFileInput } from './components'

import { AppCard, AppCardHeader, AppCardBody, AppCardHeadline, AppCardTitle, AppCardCaption, AppCardFooter } from './components'

import { AppIndicator } from './components'
import { AppFAB } from './components'

import { AppSublayer, AppSublayerHeader } from './components'

import { AppAppearAnimation, AppGroupAnimation, AppGroupItem } from './components'


const GlobalComponents = {
  install (Vue) {
    Vue.component(AppPage.name, AppPage)
    Vue.component(AppPageHeader.name, AppPageHeader)
    
    Vue.component(AppDialog.name, AppDialog)
    Vue.component(AppDialogLoading.name, AppDialogLoading)
    Vue.component(AppDialogConfirm.name, AppDialogConfirm)
    Vue.component(AppDialogDatePicker.name, AppDialogDatePicker)
    Vue.component(AppDialogDatePickerPeriod.name, AppDialogDatePickerPeriod)
     
    Vue.component(AppToolbar.name, AppToolbar)
    Vue.component(AppToolbarItem.name, AppToolbarItem)
    Vue.component(AppToolbarItemPeriod.name, AppToolbarItemPeriod)
    Vue.component(AppToolbarItemPeriodShort.name, AppToolbarItemPeriodShort)
    
    Vue.component(AppCard.name, AppCard)
    Vue.component(AppCardHeader.name, AppCardHeader)
    Vue.component(AppCardFooter.name, AppCardFooter)
    Vue.component(AppCardBody.name, AppCardBody)
    Vue.component(AppCardHeadline.name, AppCardHeadline)
    Vue.component(AppCardTitle.name, AppCardTitle)
    Vue.component(AppCardCaption.name, AppCardCaption)

    Vue.component(AppIndicator.name, AppIndicator)
    Vue.component(AppFAB.name, AppFAB)

    Vue.component(AppButton.name, AppButton)
    Vue.component(AppButtonAction.name, AppButtonAction)
    Vue.component(AppButtonCancel.name, AppButtonCancel)
    
    Vue.component(AppFileInput.name, AppFileInput)

    Vue.component(AppList.name, AppList)
    Vue.component(AppEmptyList.name, AppEmptyList)
    Vue.component(AppDatePicker.name, AppDatePicker)
    Vue.component(AppTextField.name, AppTextField)
    Vue.component(AppTextarea.name, AppTextarea)

    Vue.component(AppSelect.name, AppSelect)
    Vue.component(AppCombobox.name, AppCombobox)
    Vue.component(AppTagsCombobox.name, AppTagsCombobox)

    Vue.component(AppSublayer.name, AppSublayer)
    Vue.component(AppSublayerHeader.name, AppSublayerHeader)
    
    
    // Animation
    Vue.component(AppAppearAnimation.name, AppAppearAnimation)
    Vue.component(AppGroupAnimation.name, AppGroupAnimation)
    Vue.component(AppGroupItem.name, AppGroupItem)
  }
}

export default GlobalComponents
